import { motion } from "framer-motion";
import { ReceiptText, Scale, Handshake } from "lucide-react";

const RULES = [
  {
    icon: ReceiptText,
    title: "Proof or it doesn't count",
    body: "No verified review without a payment screenshot and a product screenshot. That single rule kills fake reviews from both sides.",
  },
  {
    icon: Scale,
    title: "We describe, we don't accuse",
    body: '"Paid ₹299, received resold free files" is a fact. "This is a scam" is a label. We stick to facts — safer for everyone, and more useful.',
  },
  {
    icon: Handshake,
    title: "Good sellers look good here",
    body: "Honest products earn honest verified reviews. This isn't anti-seller — it's anti-lying. Real value has nothing to fear.",
  },
];

export const Fairness = () => (
  <section data-testid="fairness-section" className="py-24 sm:py-32">
    <div className="max-w-6xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <div className="flex items-center gap-4">
          <span className="font-display text-4xl sm:text-5xl font-bold outline-word leading-none select-none" aria-hidden="true">07</span>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-verified">How we stay fair</p>
        </div>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight leading-tight">
          The rules that keep this honest — for buyers and sellers.
        </h2>
      </motion.div>

      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {RULES.map((r, i) => (
          <motion.div
            key={r.title}
            data-testid={`fairness-card-${i}`}
            className="rounded-2xl bg-white border border-black/5 p-8 shadow-[0_10px_36px_-14px_rgba(17,24,39,0.12)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.12 }}
          >
            <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-verified-soft text-verified">
              <r.icon size={20} />
            </span>
            <h3 className="mt-6 font-display text-xl font-semibold tracking-tight">{r.title}</h3>
            <p className="mt-3 text-sm text-gray-600 leading-relaxed">{r.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
